import React from 'react';
import { Circle, GitBranch, Share2, Network, Target } from 'lucide-react';

const GraphLayout = ({ selectedLayout, onLayoutSelect, onOpenTargets, maxNodes, onMaxNodesChange }) => {
  
  const layouts = [
    { id: 'circular', icon: Circle, label: 'Circular' },
    { id: 'tree', icon: GitBranch, label: 'Tree' },
    { id: 'force', icon: Share2, label: 'Force-Directed' },
    { id: 'network', icon: Network, label: 'Network' },
  ];

  const graphLayoutStyle = {
    display: 'flex',
    justifyContent: 'space-between',
    padding: '1rem 1.5rem',
    backgroundColor: 'white',
    borderRadius: '0.75rem',
    boxShadow: '0 1px 2px rgba(0, 0, 0, 0.05)',
    marginBottom: '1.5rem',
    gap: '1rem',
    height: '90%',
    width: '75%',
    marginLeft:'18%',
    
  };

  const layoutButtonStyle = (active) => ({
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    padding: '0.625rem 1.25rem',
    borderRadius: '0.5rem',
    transition: 'all 0.2s',
    backgroundColor: active ? '#65ccb7' : '#f9fafb',
    border: active ? '1px solid #65ccb7' : '1px solid #e5e7eb',
    color: active ? 'white' : '#374151',
    fontSize: '0.875rem',
    cursor: 'pointer',
  });

  const controlsStyle = {
    display: 'flex',
    alignItems: 'center',
    gap: '1.5rem',
  };

  const nodesControlStyle = {
    display: 'flex',
    alignItems: 'center',
    gap: '1rem',
  };

  const nodesSliderStyle = {
    width: '12rem',
    height: '0.25rem',
    backgroundColor: '#e5e7eb',
    borderRadius: '9999px',
    appearance: 'none',
    cursor: 'pointer',
  };



  const changeTargetsButtonStyle = {
    display: 'flex',
    alignItems: 'center',
    gap: '0.5rem',
    padding: '0.625rem 1.25rem',
    backgroundColor: '#65ccb7',
    color: 'white',
    borderRadius: '0.5rem',
    transition: 'opacity 0.2s',
    fontSize: '0.875rem',
    fontWeight: '500',
    cursor: 'pointer',
  };

  return (
    <div style={{ display: 'flex', width: '100%' }}>

      {/* Main Content */}
      <div style={{ flex: 1, display: 'flex', flexDirection: 'column', }}>
        {/* Graph Layout */}
        <div style={graphLayoutStyle}>
          <div style={{ display: 'flex', gap: '0.75rem' }}>
            {layouts.map(({ id, icon: Icon, label }) => (
              <button
                key={id}
                onClick={() => onLayoutSelect(id)}
                style={layoutButtonStyle(selectedLayout === id)}
              >
                <Icon className="w-5 h-5 mb-1" />
                <span>{label}</span>
              </button>
            ))}
          </div>

          <div style={controlsStyle}>
            <div style={nodesControlStyle}>
              <span style={{ fontSize: '0.875rem', color: '#374151', minWidth: '5rem' }}>Nodes: {maxNodes}</span>
              <input
                type="range"
                min="1"
                max="100"
                value={maxNodes}
                onChange={(e) => onMaxNodesChange(Number(e.target.value))}
                style={nodesSliderStyle}
              />
            </div>

            <button
              onClick={onOpenTargets}
              style={changeTargetsButtonStyle}
            >
              <Target className="w-5 h-5" />
              <span>Change Targets</span>
            </button>
          </div>
        </div>

      </div>
    </div>
  );
};

export default GraphLayout;
